import { styled } from "@mui/material"

export const SpanBox = styled("span")(() => ({
    textTransform: "capitalize",
}))
